import {configs} from '../resources/configs';
import {getAccessToken} from './AuthUtill';

const REQUEST_TIMEOUT_MS = 60000;

// One-shot request to the metrics websocket API (app-backend metrics-ws-serverless.yml):
// connects with the admin token, sends {action, message}, collects the FRAMES answer and resolves
// with the parsed payload. REST routes are capped at 29s by API Gateway, the analytics over up to a
// year of data go through here. Rejects on `errorAction`, a timeout or a dropped connection.
export const requestMetricsWebsocket = (action, message, resultAction, errorAction = 'REFUND_SAVER_ERROR') => {
  return new Promise((resolve, reject) => {
    if (!configs.metricsWsUrl) {
      reject(new Error('metricsWsUrl is not configured for this stage'));
      return;
    }
    const socket = new WebSocket(`${configs.metricsWsUrl}?token=${encodeURIComponent(getAccessToken())}`);
    const frames = [];
    let settled = false;

    const finish = (error, result) => {
      if (settled) {
        return;
      }
      settled = true;
      clearTimeout(timer);
      try {
        socket.close();
      } catch (e) {
        // already closed
      }
      error ? reject(error) : resolve(result);
    };
    const timer = setTimeout(() => finish(new Error(`${action}: no answer within ${REQUEST_TIMEOUT_MS / 1000}s`)), REQUEST_TIMEOUT_MS);

    socket.onopen = () => socket.send(JSON.stringify({action, message}));
    socket.onerror = () => finish(new Error(`${action}: websocket error`));
    socket.onclose = (event) => {
      if (!event.wasClean) {
        finish(new Error(`${action}: connection closed`));
      }
    };
    socket.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch (e) {
        return;
      }
      if (data.action !== resultAction && data.action !== errorAction) {
        return;
      }
      // FRAMES: `message` is a chunk of the JSON payload, numbered 0..countFrames-1
      if (typeof data.message === 'string' && data.countFrames) {
        frames[data.numberFrame] = data.message;
        if (frames.filter((frame) => frame !== undefined).length < data.countFrames) {
          return;
        }
        try {
          data.message = JSON.parse(frames.join(''));
        } catch (e) {
          finish(new Error(`${action}: malformed answer`));
          return;
        }
      }
      if (data.action === errorAction) {
        const reason = data.message && data.message.error;
        finish(new Error(typeof reason === 'string' ? reason : JSON.stringify(reason)));
      } else {
        finish(null, data.message);
      }
    };
  });
};
